<template>
  <div class="padding-five-lr" style="background: #f8f8f8">
    <div class="padding-ten-tb">
      <b-row style="max-width: 100%">
        <b-col xs="12" sm="6" md="6" lg="6">
          <b-button @click="goBack" class="btn-grey"> Proyectos </b-button>
        </b-col>
        <b-col xs="12" sm="6" md="6" lg="6">
          <b-breadcrumb :items="items"></b-breadcrumb>
        </b-col>
      </b-row>
    </div>
   <!-- <section>
      <b-row>
        <b-col cols="12">
          <h5 class="color-orange">Datos generales</h5>
        </b-col>
      </b-row>
    </section>
    <div class="bg-white padding-five-all">
      <b-row>
        <b-col xs="12" sm="12" md="12" lg="2">
          <label class="text-grey" for="input-small"
            >N° Orden de Servicio</label
          >
          <span>
            {{ trackingOS.sequence }}
          </span>
        </b-col>

        <b-col xs="12" sm="12" md="12" lg="2">
          <label class="text-grey" for="input-small">Tienda</label>
          <span>
            {{ trackingOS.store }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3">
          <label class="text-grey" for="input-small">SKU Servicio</label>
          <span>
            {{ trackingOS.service }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="3">
          <label class="text-grey" for="input-small">SKU Producto</label>
          <span>
            {{ trackingOS.product }}
          </span>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="2">
          <label class="text-grey" for="input-small">Proveedor</label>
          <span>
            {{ trackingOS.provider }}
          </span>
        </b-col>
      </b-row>
    </div> -->
    <section>
      <b-row>
        <b-col cols="12">
          <h5 class="color-orange">Historial</h5>
        </b-col>
      </b-row>
    </section>
    <section class="bg-white padding-five-all">
      <b-row>
        <b-col cols="12">
          <b-table :items="trackingOS" :fields="fieldsTracking">
            <template #cell(datehour)="data">
              {{ data.item.date }} {{ data.item.hour }}
            </template>
            
           
           
            <template #cell(observations)="data">
              <span v-if="!data.item.observations"> - </span>
              <span v-else> {{ data.item.observations }}</span>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </section>
  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  name: "TrackingProyecto",
  data() {
    return {
      items: [
        {
          text: "Proyectos",
          to: { name: "Proyectos" },
        },
        {
          text: "Tracking",
        },
      ],
      trackingOS: {},
      fieldsTracking: [
        {
          key: "fecha_registro",
          label: "Fecha registro",
        },
        {
          key: "usuario_modificacion",
          label: "Usuario",
        },
        {
          key: "estado",
          label: "Estado",
        },
        {
          key: "subestado",
          label: "Sub Estado",
        },
        {
          key: "motivo_desc",
          label: "Motivo",
        },
        {
          key: "observaciones",
          label: "Observaciones",
        },
      ],
    };
  },
  computed:{
    ...mapState("module", [
      "token"
    ])
  },
  created() {
    this.tracking();
  },
  methods: {
    translateTurn(value) {
      switch (value) {
        case "MORNING":
          return "MAÑANA";
        case "AFTERNOON":
          return "TARDE";
        case "ALL_DAY":
          return "DURANTE EL DÍA";
        default:
          return "-";
      }
    },
    async tracking() {
      try {
        const fetchedId = this.$route.params.id;
        if (this.$route.params.id !== fetchedId) return;
        this.$store.commit("SET_LOADING", true);
        let response = await axios.get(
          process.env.VUE_APP_PROJECT_BASE +
            "/tracking?idProject=" +
            this.$route.params.id,
            {
              headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer "+ this.token
              },
            }
        );
        console.log(response);

        this.trackingOS = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("SET_LOADING", false);
      }
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
::v-deep.breadcrumb {
  background: transparent !important;
  justify-content: flex-end !important;
  color: #676767;
  font-weight: bold;
}
::v-deep .b-table thead {
  background-color: transparent !important;
  color: black !important;
  font-weight: 500 !important;
  border: none !important;
}
::v-deep .table tr:first-child td {
  border-top: 1px solid transparent !important;
}
::v-deep .b-table thead th {
  font-weight: 700 !important;
  border: none !important;
  font-size: 11pt;
}
::v-deep .table td {
  color: black;
  font-size: 11pt;
}
::v-deep .table-striped tbody tr:nth-of-type(odd) {
  background-color: transparent;
}
.hidden-lg {
  display: none;
}
@media (max-width: 575.98px) {
  .hidden-xs {
    display: none;
  }
  .visible-xs {
    visibility: visible;
  }
  .hidden-lg {
    display: block;
  }
}
.btn-secondary {
  background: transparent !important;
  border-color: transparent !important;
}
.btn-secondary:focus {
  box-shadow: none;
}
.btn-secondary:active {
  box-shadow: none;
}
.btn-secondary:not(:disabled):not(.disabled):active:focus {
  box-shadow: none;
}
.back-grey {
  background: #f4f4f4;
}
.btn-grey {
  background: transparent !important;
  color: #676767 !important;
  border-color: transparent !important;
  font-weight: bolder;
}

.padding-ten-lr {
  padding: 10px;
}

.color-gray-dark {
  color: #575757;
}
.padding-five-top {
  padding-top: 15px;
}
.padding-twenty-seven-lr {
  padding-left: 27px;
  padding-right: 27px;
}
.card {
  background: transparent !important;
  border: none !important;
}
.margin-botttom-none {
  margin-bottom: 0;
}
a:hover {
  color: rgb(254, 123, 1) !important;
}
a {
  color: #676767 !important;
}
.center-div {
  position: absolute;
  position: relative;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.center-ver {
  position: absolute;
  top: 50%;
  left: 50%;
  -moz-transform: translateX(-50%) translateY(-50%);
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
}
.bolder {
  font-weight: 700;
}

.v1 {
  border-left: 1px solid gray;
  height: 100%;
  position: absolute;
  right: 0;
  margin-left: -3px;
  top: 0;
}
.circle-orange {
  border-radius: 50%;
  border-color: orange;
  height: 15px;
  width: 15px;
  background-color: orange;
  border-radius: 50%;
  display: inline-block;
  position: absolute;
  top: 50%;
  right: -7px;
  margin-left: -3px;
}
.padding-ten-bottom {
  padding-bottom: 15px;
}
.text-grey {
  color: #676767;
  font-size: 15px;
  letter-spacing: 0px;
  display: block;
  margin-bottom: 0.5rem;
}
.text-right {
  text-align: right;
}
</style>
